import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

import { MENU_BUTTON_TEST_ID, MENU_ICON_TEST_ID } from './constants';

import type { FC } from 'react';

interface MenuButtonProps {
  onClick(): void;
}

export const MenuButton: FC<MenuButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      data-testid={MENU_BUTTON_TEST_ID}
      onClick={onClick}
      aria-label={t('GSP.layouts.mainLayout.header.menuButton.ariaLabel')}
    >
      <MenuIcon data-testid={MENU_ICON_TEST_ID} color="action" />
    </IconButton>
  );
};
